<script setup lang="ts">
  import { ref, type PropType } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  type Brand = {
    id: number;
    name: string;
    slug: string;
    photo: string | null;
  }

  defineProps({
    header: String,
    headerType: String,
    brands: { type: Array as PropType<Brand[]>},
    enableAutoplay: Boolean,
    timeAutoplay: [Number, String],
    speed: [Number, String],
  });

  const parameters = ref({
    navigation: true,
    breakpoints: {
      1: {
        slidesPerView: 4.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      576: {
        slidesPerView: 5.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      768: {
        slidesPerView: 6.5,
        spaceBetween: 10,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
      },
      992: {
        slidesPerView: 8,
        spaceBetween: 16,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
</script>
<template>
  <SfSection :title="header" :headerType :link="$route('web.brand.index')">
    <SfBrandsCarousel :brands :parameters  :enableAutoplay :timeAutoplay :speed />
  </SfSection>
</template>
